export const shortlanguageList = [
  'en',
  'ja',
  'zh',
  'es',
  'th',
  'id',
  'my',
  'ko',
  'ru',
  'vi',
  'fr',
  'pt',
  'hi',
  'ms',
  'es-es',
  'es-la',
  'pt-br',
  'pt-pt',
  'ar',
  'bn',
  'tr',
  'en-sc',
  'mm-sc',
]

export const getShortLang = (languageList: string[], languageWithoutFormat: string) => {
  const specialLang = new Map([
    ['pt_pt', 'pt-pt'],
    ['pt_br', 'pt-br'],
    ['es_es', 'es-es'],
    ['es_la', 'es-la'],
    ['ar_ae', 'ar-ae'],
    ['bn_bd', 'bn-bd'],
    ['fr_fr', 'fr-fr'],
    ['tr_tr', 'tr-tr'],
  ])

  const language = languageWithoutFormat.toLowerCase()

  if (specialLang.has(language)) {
    const newLocal = specialLang.get(language) ?? 'en'
    if (!languageList.includes(newLocal)) return 'en'
    return newLocal
  }

  const shortLanguage = language.slice(0, 2)
  if (!languageList.includes(shortLanguage)) {
    return 'en'
  }

  transformShortLanguage(shortLanguage)

  if (languageList.includes(shortLanguage)) {
    return shortLanguage
  }

  return 'en'
}

const transformShortLanguage = (shortLanguage: string) => {
  switch (shortLanguage) {
    case 'en':
    case 'us':
      return 'en'
    case 'ja':
    case 'jp':
      return 'ja'
    case 'zh':
    case 'tw':
    case 'cn':
      return 'zh'
    case 'th':
      return 'th'
    case 'id':
      return 'id'
    case 'my':
    case 'mm':
      return 'my'
    case 'de':
      return 'de'
    case 'ko':
    case 'kr':
      return 'ko'
    case 'ru':
      return 'ru'
    case 'ms':
      return 'ms'
    case 'vi':
    case 'vn':
      return 'vi'
    case 'fr':
      return 'fr'
    case 'hi':
      return 'hi'
    default:
      return 'en'
  }
}
